import request from '@/api/request'

const url = '/dept'

// 查询所有
export const getAllDept = (deptId) => {
    return request({
        url: url + '/all/' + deptId
    })
}